/**
 * Frontend Release History (External user)
 *
 * This file tracks all external user frontend releases with their versions,
 * builds, and deployment information.
 * Release type: Feature, Bugfix, Hotfix, Security, Update, Maintenance
 * Commit type: feat, fix, docs, style, refactor, perf, test, chore, ci, build, i18n
 */
const RELEASES = [
  {
    id: 'ext-v4.4.2+01',
    version: 'ext-v4.4.2',
    type: 'Bugfix',
    title: 'Validate additional ECTS fields and improve inline layout',
    build: {
      number: '01',
      author: 'symeon',
      startDate: '2026-05-19',
      date: '2026-05-21',
      commits: [
        {
          type: 'docs',
          message: 'Update release history for ext-v4.4.2',
          date: '2026-05-21',
          sha: 'xxxxxxxx',
          author: 'symeon',
          issues: [110],
        },
        {
          type: 'fix',
          message: 'Delay additional ECTS validation message until interaction',
          date: '2026-05-21',
          sha: 'f91664eff7f863c8aee930e81d8618ded3129ce1',
          author: 'symeon',
          issues: [110],
        },
        {
          type: 'fix',
          message: 'Validate additional ECTS and refine inline layout',
          date: '2026-05-20',
          sha: '85ad4978b67978113ef339e0f4322407beb93281',
          author: 'symeon',
          issues: [110],
        },
        {
          type: 'build',
          message: 'Update local web server port configuration',
          date: '2026-05-19',
          sha: 'f1883a5cfc32794dfaff55df62500efdec3389b1',
          author: 'symeon',
          issues: [],
        },
        {
          type: 'build',
          message: 'Update backend port configuration for local development',
          date: '2026-05-19',
          sha: '39b63c56ae448169b939221eee0c7d2feef11d9d',
          author: 'symeon',
          issues: [],
        },
      ],
    },
  },
  {
    id: 'ext-v4.4.1+01',
    version: 'ext-v4.4.1',
    type: 'Bugfix',
    title: 'Send hierarchical selection data on save for legacy applications',
    build: {
      number: '01',
      author: 'symeon',
      startDate: '2026-04-24',
      date: '2026-04-24',
      commits: [
        {
          type: 'docs',
          message: 'Add release 4.4.1 entry',
          date: '2026-04-24',
          sha: '7bf6981434018b03647e389dbbed9bd7e7573960',
          author: 'symeon',
          issues: [88],
        },
      ],
    },
  },
  {
    id: 'ext-v4.4.1-rc.1+01',
    version: 'ext-v4.4.1-rc.1',
    type: 'Bugfix',
    title: 'Send hierarchical selection data on save for legacy applications',
    build: {
      number: '01',
      author: 'symeon',
      startDate: '2026-04-23',
      date: '2026-04-23',
      commits: [
        {
          type: 'fix',
          message: 'Send hierarchical selection data on save for legacy applications',
          date: '2026-04-23',
          sha: '483500b454045d573fd707353ea82f9acd1c6e74',
          author: 'symeon',
          issues: [88],
        },
      ],
    },
  },
  {
    id: 'ext-v4.4.0+01',
    version: 'ext-v4.4.0',
    type: 'Feature',
    title: 'Add hierarchical title programme selection',
    build: {
      number: '01',
      author: 'symeon',
      startDate: '2026-04-21',
      date: '2026-04-21',
      commits: [
        {
          type: 'docs',
          message: 'Add release 4.4.0 entry',
          date: '2026-04-21',
          sha: '064943c3b0316f4c22e333aa250fcd983d52f568',
          author: 'symeon',
          issues: [88],
        },
      ],
    },
  },
  {
    id: 'ext-v4.4.0-rc.8+01',
    version: 'ext-v4.4.0-rc.8',
    type: 'Feature',
    title: 'Add hierarchical title programme selection',
    build: {
      number: '01',
      author: 'symeon',
      startDate: '2026-04-17',
      date: '2026-04-20',
      commits: [
        {
          type: 'refactor',
          message: 'Simplify title selection levels with data-driven config',
          date: '2026-04-20',
          sha: '88ca26d39636ccd6f92c10b363a8944b6849b85a',
          author: 'symeon',
          issues: [88],
        },
        {
          type: 'feat',
          message: 'Auto-select on blur: exact match, single partial match, or clear',
          date: '2026-04-20',
          sha: 'd9a456a3b4ea09322fbbcfc5fe9cc786ac8c4d78',
          author: 'symeon',
          issues: [88],
        },
      ],
    },
  },
  {
    id: 'ext-v4.4.0-rc.7+01',
    version: 'ext-v4.4.0-rc.7',
    type: 'Feature',
    title: 'Add hierarchical title programme selection',
    build: {
      number: '01',
      author: 'symeon',
      startDate: '2026-04-16',
      date: '2026-04-16',
      commits: [
        {
          type: 'fix',
          message: 'Fix correspondence validation skip bug',
          date: '2026-04-16',
          sha: '8d3eba10305e8a6dfdc6eb934643c7e407f8989a',
          author: 'symeon',
          issues: [88],
        },
      ],
    },
  },
  {
    id: 'ext-v4.4.0-rc.6+01',
    version: 'ext-v4.4.0-rc.6',
    type: 'Feature',
    title: 'Add hierarchical title programme selection',
    build: {
      number: '01',
      author: 'symeon',
      startDate: '2026-04-15',
      date: '2026-04-15',
      commits: [
        {
          type: 'fix',
          message: 'Fix empty autocomplete list after clear button press',
          date: '2026-04-15',
          sha: 'e6a5dee5185fc6c6d8c64282be2681905e7de074',
          author: 'symeon',
          issues: [88],
        },
        {
          type: 'feat',
          message: 'Sort autocomplete options alphabetically by active locale',
          date: '2026-04-15',
          sha: '18e70d3d8f2be2baaed407c57bbd1a11cf7eb815',
          author: 'symeon',
          issues: [88],
        },
      ],
    },
  },
  {
    id: 'ext-v4.4.0-rc.5+01',
    version: 'ext-v4.4.0-rc.5',
    type: 'Feature',
    title: 'Add hierarchical title programme selection',
    build: {
      number: '01',
      author: 'symeon',
      startDate: '2026-04-06',
      date: '2026-04-09',
      commits: [
        {
          type: 'fix',
          message: 'Normalize title correspondence fields on load and interaction',
          date: '2026-04-09',
          sha: 'ab44bc04422372ee5b23ec50698bbee3127aeeff',
          author: 'symeon',
          issues: [88],
        },
        {
          type: 'feat',
          message: 'Add English name support across all programme selection levels',
          date: '2026-04-08',
          sha: '17ef8125876e32c7ff31f994431766e9b6a0c2ec',
          author: 'symeon',
          issues: [88],
        },
      ],
    },
  },
  {
    id: 'ext-v4.4.0-rc.4+01',
    version: 'ext-v4.4.0-rc.4',
    type: 'Feature',
    title: 'Add hierarchical title programme selection',
    build: {
      number: '01',
      author: 'symeon',
      startDate: '2026-03-27',
      date: '2026-03-27',
      commits: [
        {
          type: 'chore',
          message: 'Update field of study label',
          date: '2026-03-27',
          sha: '9d84a2d9295a092ac7faa3c3e16c6ef29d3f8add',
          author: 'symeon',
          issues: [88],
        },
      ],
    },
  },
  {
    id: 'ext-v4.4.0-rc.3+01',
    version: 'ext-v4.4.0-rc.3',
    type: 'Feature',
    title: 'Add hierarchical title programme selection',
    build: {
      number: '01',
      author: 'symeon',
      startDate: '2026-03-11',
      date: '2026-03-12',
      commits: [
        {
          type: 'fix',
          message: 'Prevent title selection completion and correspondence validation checks if application type is recognition and degree type is not bachelor',
          date: '2026-03-12',
          sha: 'd1752020a6e12a4b9a2f20625f7de40d912d801a',
          author: 'symeon',
          issues: [88],
        },
      ],
    },
  },
  {
    id: 'ext-v4.4.0-rc.2+01',
    version: 'ext-v4.4.0-rc.2',
    type: 'Feature',
    title: 'Add hierarchical title programme selection',
    build: {
      number: '01',
      author: 'symeon',
      startDate: '2026-03-09',
      date: '2026-03-09',
      commits: [
        {
          type: 'feat',
          message: 'Update hierarchical title selection feature placeholder texts',
          date: '2026-03-09',
          sha: 'd224257ceb69b4eb0c1015d5d36815129478ef18',
          author: 'symeon',
          issues: [88],
        },
        {
          type: 'fix',
          message: 'Prevent title selection completion check if application is submitted',
          date: '2026-03-09',
          sha: '364a85d3f5917191f9f83203be665c438b3b9de8',
          author: 'symeon',
          issues: [88],
        },
        {
          type: 'fix',
          message: 'Fix styling side effects on autocomplete elements and force line break before select pdf attachment form item',
          date: '2026-03-09',
          sha: '7355cbc4c1272c90d6e1e8bc58e8d8b36d1aca03',
          author: 'symeon',
          issues: [88],
        },
      ],
    },
  },
  {
    id: 'ext-v4.4.0-rc.1+01',
    version: 'ext-v4.4.0-rc.1',
    type: 'Feature',
    title: 'Add hierarchical title programme selection',
    build: {
      number: '01',
      author: 'symeon',
      startDate: '2026-02-09',
      date: '2026-02-27',
      commits: [
        {
          type: 'feat',
          message: 'Add hierarchical title programme selection',
          date: '2026-02-27',
          sha: 'ffa2793b2c2539cad4a2a4a036764c8584138def',
          author: 'symeon',
          issues: [88],
        },
      ],
    },
  },
  {
    id: 'ext-v4.3.2+01',
    version: 'ext-v4.3.2',
    type: 'Bugfix',
    title: 'Increase university name field max length to 255 characters',
    build: {
      number: '01',
      author: 'symeon',
      startDate: '2026-02-17',
      date: '2026-02-19',
      commits: [
        {
          type: 'fix',
          message: 'Increase university name field max length to 255 characters',
          date: '2026-02-19',
          sha: '7112843eb2525b49a197ade667fa422dc82ff74e',
          author: 'symeon',
          issues: [105],
        },
        {
          type: 'fix',
          message: 'Increase university name max length to 150 in Co-submission tab',
          date: '2026-02-17',
          sha: '615f6c22bf0efaa5907023223c2400915b7f0be6',
          author: 'symeon',
          issues: [105],
        },
      ],
    },
  },
  {
    id: 'ext-v4.3.1+01',
    version: 'ext-v4.3.1',
    type: 'Feature',
    title: 'Add contact information editing',
    build: {
      number: '01',
      author: 'symeon',
      startDate: '2026-01-14',
      date: '2026-01-28',
      commits: [
        {
          type: 'fix',
          message: 'Align contact information update field names with backend changes',
          date: '2026-01-28',
          sha: '1f6967abff0e599f47fffeb8f6706d85befba121',
          author: 'symeon',
          issues: [89],
        },
        {
          type: 'feat',
          message: 'Add contact information editing',
          date: '2026-01-21',
          sha: '3dcecc1d1b397ccc54508d000593ba7357d5a2d4',
          author: 'symeon',
          issues: [89],
        },
        {
          type: 'feat',
          message: 'Add full release history page',
          date: '2026-01-21',
          sha: 'f70f9e82a6021b1456c5d88bb6150719ff612f21',
          author: 'symeon',
          issues: [],
        },
      ],
    },
  },
  {
    id: 'ext-v4.3.0+02',
    version: 'ext-v4.3.0',
    type: 'Feature',
    title: 'Add post-exam application support',
    build: {
      number: '02',
      author: 'symeon',
      startDate: '2026-01-13',
      date: '2026-01-14',
      commits: [
        {
          type: 'chore',
          message: 'Refine release history structure and footer tooltip',
          date: '2026-01-13',
          sha: 'a4890f83a563f8e883339fbc183531c668992f75',
          author: 'symeon',
          issues: [],
        },
        {
          type: 'style',
          message: 'Style first bachelor degree section on Titles tab',
          date: '2026-01-14',
          sha: 'ad3f2b0d4f51dbe11a94079ed097e9ee7efd5338',
          author: 'symeon',
          issues: [81],
        },
      ],
    },
  },
  {
    id: 'ext-v4.3.0+01',
    version: 'ext-v4.3.0',
    type: 'Feature',
    title: 'Add post-exam application support',
    build: {
      number: '01',
      author: 'symeon',
      startDate: '2025-12-11',
      date: '2025-12-11',
      commits: [
        {
          type: 'feat',
          message: 'Add post-exam application support',
          date: '2025-12-11',
          sha: '4ec401983fd9d278d7d43e40aa1821119ebf7ea2',
          author: 'symeon',
          issues: [90, 99],
        },
      ],
    },
  },
  {
    id: 'ext-v4.3.0-rc.1+03',
    version: 'ext-v4.3.0-rc.1',
    type: 'Feature',
    title: 'Add post-exam application support (RC)',
    build: {
      number: '03',
      author: 'symeon',
      startDate: '2025-12-10',
      date: '2025-12-10',
      commits: [
        {
          type: 'feat',
          message: 'Add build metadata to releases and display in footer tooltips',
          date: '2025-12-10',
          sha: 'b2f67e93c61e0e21408c9a3e2294b876b0aeb7c3',
          author: 'symeon',
          issues: [],
        },
      ],
    },
  },
  {
    id: 'ext-v4.3.0-rc.1+02',
    version: 'ext-v4.3.0-rc.1',
    type: 'Feature',
    title: 'Add post-exam application support (RC)',
    build: {
      number: '02',
      author: 'symeon',
      startDate: '2025-12-10',
      date: '2025-12-10',
      commits: [
        {
          type: 'style',
          message: 'Update UI texts for post-exam applications',
          date: '2025-12-10',
          sha: 'a329590930f2096d390cf61d07953d7a58761d6f',
          author: 'symeon',
          issues: [90, 99],
        },
      ],
    },
  },
  {
    id: 'ext-v4.3.0-rc.1+01',
    version: 'ext-v4.3.0-rc.1',
    type: 'Feature',
    title: 'Add post-exam application support (RC)',
    build: {
      number: '01',
      author: 'symeon',
      startDate: '2025-11-27',
      date: '2025-12-10',
      commits: [
        {
          type: 'feat',
          message: 'Add post-exam application support (RC 1)',
          date: '2025-11-28',
          sha: '03d728e4b825ea1ccc9a54821646a6795b63b144',
          author: 'symeon',
          issues: [90, 99],
        },
      ],
    },
  },
  {
    id: 'ext-v4.2.6+01',
    version: 'ext-v4.2.6',
    type: 'Feature',
    title: 'Add accessibility widget',
    build: {
      number: '01',
      author: 'symeon',
      startDate: '2025-10-16',
      date: '2025-10-16',
      commits: [
        {
          type: 'feat',
          message: 'Add accessibility widget',
          date: '2025-10-16',
          sha: 'd04e6a2cf07cbc63a4424fb4d139e5c7a4d0f16a',
          author: 'symeon',
          issues: [26],
        },
      ],
    },
  },
  {
    id: 'ext-v4.2.5+01',
    version: 'ext-v4.2.5',
    type: 'Feature',
    title: 'Production release v4.2.5',
    build: {
      number: '01',
      author: 'symeon',
      startDate: '2025-10-07',
      date: '2025-10-07',
      commits: [
        {
          type: 'build',
          message: 'Production release v4.2.5',
          date: '2025-10-07',
          sha: '51651cd223fae89ccc1c899a97f4520fe44f4326',
          author: 'symeon',
          issues: [],
        },
      ],
    },
  },
  {
    id: 'ext-v4.2.5-dev.1+01',
    version: 'ext-v4.2.5-dev.1',
    type: 'Update',
    title: 'Change date format and update download date (DEV)',
    build: {
      number: '01',
      author: 'symeon',
      startDate: '2025-10-02',
      date: '2025-10-02',
      commits: [
        {
          type: 'style',
          message: 'Change date format (Issue #60) and update download date (Issue #45)',
          date: '',
          sha: '',
          author: 'symeon',
          issues: [60, 45],
        },
      ],
    },
  },
  {
    id: 'ext-v4.2.4+01',
    version: 'ext-v4.2.4',
    type: 'Bugfix',
    title: 'Fix submit choice text',
    build: {
      number: '01',
      author: 'symeon',
      startDate: '2025-09-08',
      date: '2025-09-08',
      commits: [
        {
          type: 'fix',
          message: 'Fix submit choice text',
          date: '',
          sha: '',
          author: 'symeon',
          issues: [],
        },
      ],
    },
  },
  {
    id: 'ext-v4.2.3+01',
    version: 'ext-v4.2.3',
    type: 'Update',
    title: 'Translate form validation messages',
    build: {
      number: '01',
      author: 'symeon',
      startDate: '2025-07-30',
      date: '2025-07-30',
      commits: [
        {
          type: 'i18n',
          message: 'Translate form validation messages',
          date: '',
          sha: '',
          author: 'symeon',
          issues: [],
        },
      ],
    },
  },
  {
    id: 'ext-v4.2.2+01',
    version: 'ext-v4.2.2',
    type: 'Update',
    title: 'Update translations of "Application reappraisal" as "Reevaluation of decision"',
    build: {
      number: '01',
      author: 'symeon',
      startDate: '2025-07-23',
      date: '2025-07-23',
      commits: [
        {
          type: 'i18n',
          message: 'Update translations of "Application reappraisal" as "Reevaluation of decision"',
          date: '',
          sha: '',
          author: 'symeon',
          issues: [],
        },
      ],
    },
  },
  {
    id: 'ext-v4.2.1+01',
    version: 'ext-v4.2.1',
    type: 'Update',
    title: 'Update text of Application Status field value',
    build: {
      number: '01',
      author: 'symeon',
      startDate: '2025-07-22',
      date: '2025-07-22',
      commits: [
        {
          type: 'style',
          message: 'Update text of Application Status field value',
          date: '',
          sha: '',
          author: 'symeon',
          issues: [],
        },
      ],
    },
  },
  {
    id: 'ext-v4.2.0+01',
    version: 'ext-v4.2.0',
    type: 'Feature',
    title: 'Add reappraisal applications support',
    build: {
      number: '01',
      author: 'symeon',
      startDate: '2025-07-04',
      date: '2025-07-04',
      commits: [
        {
          type: 'feat',
          message: 'Add reappraisal applications support',
          date: '',
          sha: '',
          author: 'symeon',
          issues: [],
        },
      ],
    },
  },
  {
    id: 'ext-v4.2.0-rc.3+01',
    version: 'ext-v4.2.0-rc.3',
    type: 'Feature',
    title: 'Second test changes (RC)',
    build: {
      number: '01',
      author: 'symeon',
      startDate: '2025-07-03',
      date: '2025-07-03',
      commits: [
        {
          type: 'chore',
          message: 'Second test changes',
          date: '',
          sha: '',
          author: 'symeon',
          issues: [],
        },
      ],
    },
  },
  {
    id: 'ext-v4.2.0-rc.2+01',
    version: 'ext-v4.2.0-rc.2',
    type: 'Feature',
    title: 'First test changes (RC)',
    build: {
      number: '01',
      author: 'symeon',
      startDate: '2025-07-01',
      date: '2025-07-01',
      commits: [
        {
          type: 'chore',
          message: 'First test changes',
          date: '',
          sha: '',
          author: 'symeon',
          issues: [],
        },
      ],
    },
  },
  {
    id: 'ext-v4.2.0-rc.1+01',
    version: 'ext-v4.2.0-rc.1',
    type: 'Feature',
    title: 'Add reappraisal entries in history chart (RC)',
    build: {
      number: '01',
      author: 'symeon',
      startDate: '2025-06-09',
      date: '2025-06-09',
      commits: [
        {
          type: 'feat',
          message: 'Add reappraisal entries in history chart',
          date: '',
          sha: '',
          author: 'symeon',
          issues: [],
        },
        {
          type: 'fix',
          message: 'Minor fixes',
          date: '',
          sha: '',
          author: 'symeon',
          issues: [],
        },
      ],
    },
  },
  {
    id: 'ext-v4.2.0-dev.3+01',
    version: 'ext-v4.2.0-dev.3',
    type: 'Feature',
    title: 'Add reappraisal entries in history chart (DEV)',
    build: {
      number: '01',
      author: 'symeon',
      startDate: '2025-05-13',
      date: '2025-05-13',
      commits: [
        {
          type: 'feat',
          message: 'Add reappraisal entries in history chart',
          date: '',
          sha: '',
          author: 'symeon',
          issues: [],
        },
        {
          type: 'fix',
          message: 'Minor fixes',
          date: '',
          sha: '',
          author: 'symeon',
          issues: [],
        },
      ],
    },
  },
  {
    id: 'ext-v4.2.0-dev.2+01',
    version: 'ext-v4.2.0-dev.2',
    type: 'Feature',
    title: 'Split frontend and backend versions for debugging (DEV)',
    build: {
      number: '01',
      author: 'symeon',
      startDate: '2025-04-11',
      date: '2025-04-11',
      commits: [
        {
          type: 'feat',
          message: 'Split frontend and backend versions for debugging',
          date: '',
          sha: '',
          author: 'symeon',
          issues: [],
        },
        {
          type: 'fix',
          message: 'Minor fixes',
          date: '',
          sha: '',
          author: 'symeon',
          issues: [],
        },
      ],
    },
  },
  {
    id: 'ext-v4.2.0-dev.1+01',
    version: 'ext-v4.2.0-dev.1',
    type: 'Feature',
    title: 'Reappraisals 2024 (DEV)',
    build: {
      number: '01',
      author: 'symeon',
      startDate: '2024',
      date: '2024',
      commits: [
        {
          type: 'feat',
          message: 'Reappraisals 2024',
          date: '',
          sha: '',
          author: 'symeon',
          issues: [],
        },
      ],
    },
  },
]
// Active release = first element
export const FRONTEND_RELEASE = `${RELEASES[0].version} (build ${RELEASES[0].build.number})`
// Export RELEASES array for use in config
export { RELEASES }
